<template>
  <div class="row">
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="First Name" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="Last Name" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="country-select clearfix">
          <select class="myniceselect nice-select wide">
            <option v-for="country in countries" :key="country.short" :value="country.short" :selected="country.short == countries[0].short">{{country.full}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="Company Name" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <!--                                            <label>Address <span class="required">*</span></label>-->
          <input placeholder="Street address" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="Apartment, suite, unit etc. (optional)" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input type="text" placeholder="Town / City">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="State / County" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="Postcode / Zip" type="text">
        </div>
      </div>
      <div class="col-md-6">
        <div class="checkout-form-list">
          <input placeholder="Email Address" type="email">
        </div>
      </div>
      <div class="col-md-12">
        <div class="checkout-form-list">
          <input placeholder="Phone" type="text">
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "BillingForm",
  props: ['countries']
}
</script>

<style>

</style>
